import React from 'react';
import { Alert } from 'cstar-react-primitives/lib/redux-form/alert/Alert';
import { Container } from 'cstar-react-primitives/lib/redux-form/layout/Container';

import errorMessages from './errorMessages';


const ErrorRefresh = () => (
    <Container hasSlimPadding>
        <Alert
            alertType="error"
            hasHeading
            heading={errorMessages.errorRefreshTitle}
            message={errorMessages.errorRefreshDescription}
        />
    </Container>
);

export default ErrorRefresh;
